import { isSuperAdminRoleType } from './accountRoleClassification';
import { isReportingSupervisorValue } from './behaviourAccess';
import { isPendingLeaveStatus } from './leaveStatus';

const CAN_LEAVE_ACCESS_ROLE_TYPES = new Set(['assistant_manager_002']);

export function hasCanLeaveAccess(roleType) {
  const normalized = String(roleType || '').trim().toLowerCase();
  if (isSuperAdminRoleType(normalized)) return true;
  return CAN_LEAVE_ACCESS_ROLE_TYPES.has(normalized);
}

export function leaveApplyStatusForRole(roleType) {
  return hasCanLeaveAccess(roleType) ? 'approved' : 'pending';
}

export function canSeeTeamLeaveList({ roleType, isReportingSupervisor } = {}) {
  return hasCanLeaveAccess(roleType) || isReportingSupervisorValue(isReportingSupervisor);
}

function isFinalLeaveStatus(status) {
  return /approved|rejected|cancel/i.test(String(status || ''));
}

function canCancelLeaveStatus(status) {
  const value = String(status || '').trim().toLowerCase();
  return value === 'requested' || value === 'pending';
}

/**
 * Action buttons for a leave row:
 * - Super Admin / assistant_manager_002: View, Accept, Reject
 * - Reporting supervisor on a report's leave: View, Edit, Accept, Reject
 * - Employee (including supervisor's own leave): View, Edit, Cancel
 */
export function getLeaveRowActionFlags({
  status,
  isOwnLeave,
  roleType,
  isReportingSupervisor,
} = {}) {
  const isFinal = isFinalLeaveStatus(status);
  const showEditPending = isPendingLeaveStatus(status);
  const isSupervisor = isReportingSupervisorValue(isReportingSupervisor);

  if (isSuperAdminRoleType(roleType)) {
    return {
      isFinal,
      showEdit: false,
      showCancel: false,
      showAcceptReject: true,
    };
  }

  if (isSupervisor && !isOwnLeave) {
    return {
      isFinal,
      showEdit: showEditPending,
      showCancel: false,
      showAcceptReject: true,
    };
  }

  if (hasCanLeaveAccess(roleType)) {
    return {
      isFinal,
      showEdit: false,
      showCancel: false,
      showAcceptReject: true,
    };
  }

  return {
    isFinal,
    showEdit: showEditPending,
    showCancel: canCancelLeaveStatus(status),
    showAcceptReject: false,
  };
}
